import { render } from "./ordeType.vue?vue&type=template&id=30345adc"
import script from "./ordeType.vue?vue&type=script&lang=js"
export * from "./ordeType.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__